
import { templates as templates_openapi } from "@yulintu/freesia-design-openapi";
import MainEntry from "./components/MainEntry";
import Immersive from "./components/pages/Immersive";
import AppPortalCard from "./components/pages/AppPortalCard";
import CopyRight from "./components/pages/CopyRight";
import NotFound from "./components/pages/NotFound";
import { templates as templates_task } from "@yulintu/freesia-design-task";
import ToTarget from "./components/pages/ToTarget";
import { templates as templates_dataflow } from "@yulintu/freesia-design-dataflow";

const templates = [
    ...templates_openapi,
    ...templates_task,
    ...templates_dataflow,
    {
        Component: MainEntry,
        name: 'main-entry',
        pure: true
    },
    {
        Component: Immersive,
        name: '@system/immersive'
    },
    {
        Component: AppPortalCard,
        name: '@system/pages/app-portal-card'
    },
    {
        Component: CopyRight,
        name: '@system/addons/copyright'
    },
    {
        Component: NotFound,
        name: '@system/addons/not-found'
    },
    {
        Component: ToTarget,
        name: '@system/addons/to-target'
    }
]

export default templates;